
const ItemContainer = require('./ItemContainer.jsx');
const ItemMeta = require('./ItemMeta.jsx');
const Name = require('../utility/Name.jsx');
const Signature = require('../common/Signature.jsx');
const Statement = require('./Statement.jsx');

// LEGACY
const Item = require('./Item.jsx');

const Blocks = {
    get: (group, data) => [
        {
            id: 'certificateSeparator',
            dataType: 'separator', 
            display: 'Certificate of Authenticity', 
            group
        },
        {
            id: Name.Block.Inventory.Container,
            component: ItemContainer.PageV2,
            config: {
                Block: ItemContainer.TypeConfigV2.panel.block(),
                Style: ItemContainer.TypeConfigV2.panel.style(),
                Visibility: ItemContainer.TypeConfigV2.panel.visibility(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: ItemContainer.TypeConfigV2.defaultDesign(data) }
                ]
            },
            display: 'Item Container',
            group,
            image: '',
            type: 'container'
        },
        {
            id: Name.Block.AuthenticityStatement,
            component: Statement.V2.Component,
            config: {
                Block: Statement.V2.TypeConfig.panel.block(),
                Style: Statement.V2.TypeConfig.panel.style(),
            },
            display: 'Authenticity Statement',
            group,
            image: ''
        },
        {
            id: Name.Block.Signature,
            component: Signature.V2.Component,
            config: {
                Block: Signature.V2.TypeConfig.panel.block(true),
                Style: Signature.V2.TypeConfig.panel.style(),
                Description: Signature.V2.TypeConfig.panel.description(),
                Label: Signature.V2.TypeConfig.panel.label(),
                Value: Signature.V2.TypeConfig.panel.value()
            },
            display: 'Signature Line',
            group,
            image: ''
        }
    ],
    content: {
        [Name.Block.Inventory.Container]: ItemContainer.Blocks
    },
    tokens: (id, data) => {
        switch (id) {
            case Name.Block.AuthenticityStatement:
                return Statement.V2.Tokens();
            case Name.Block.Inventory.Meta:
                return ItemMeta.Tokens(data);
        }
    },

    legacy: [
        { display: 'Certificate Data Blocks', type: 'header' },
        {
            id: 'statement',
            component: Statement.V1.Component,
            config: {
                Block: Statement.V1.TypeConfig.panel.block(),
                Style: Statement.V1.TypeConfig.panel.style(),
            },
            display: 'Statement',
            image: ''
        },
        {
            id: 'signature',
            component: Signature.V1.Component,
            config: {
                Block: Signature.V1.TypeConfig.panel.block(),
                Includes: Signature.V1.TypeConfig.panel.includes(),
                Style: Signature.V1.TypeConfig.panel.style()
            },
            display: 'Signature',
            image: ''
        },
        { display: 'Item Data Blocks', type: 'header' },
        {
            id: 'itemContainer',
            component: ItemContainer.Page,
            config: {
                Block: ItemContainer.TypeConfig.panel.block(),
                Columns: ItemContainer.TypeConfig.panel.columns(),
                Style: ItemContainer.TypeConfig.panel.style()
            },
            display: 'Item Container (required)',
            image: '',
            type: 'container'
        },
        {
            id: 'itemImage',
            component: Item.Image.Component,
            config: {
                Block: Item.Image.TypeConfig.panel.block(),
                Style: Item.Image.TypeConfig.panel.style()
            },
            display: 'Image',
            image: ''
        },
        {
            id: 'itemArtist',
            component: Item.Artist.Component,
            config: {
                Block: Item.Artist.TypeConfig.panel.block(),
                Style: Item.Artist.TypeConfig.panel.style()
            },
            display: 'Artist',
            image: ''
        },
        {
            id: 'itemTitle',
            component: Item.Title.Component,
            config: {
                Block: Item.Title.TypeConfig.panel.block(),
                Includes: Item.Title.TypeConfig.panel.includes(),
                Style: Item.Title.TypeConfig.panel.style()
            },
            display: 'Title',
            image: ''
        },
        {
            id: 'itemEdition',
            component: Item.Edition.Component,
            config: {
                Block: Item.Edition.TypeConfig.panel.block(),
                Visibility: Item.Edition.TypeConfig.panel.visibility(),
                Style: Item.Edition.TypeConfig.panel.style(),
                Format: Item.Edition.TypeConfig.panel.format()
            },
            display: 'Edition',
            image: ''
        },
        {
            id: 'itemYear',
            component: Item.Year.Component,
            config: {
                Block: Item.Year.TypeConfig.panel.block(),
                Visibility: Item.Year.TypeConfig.panel.visibility(),
                Style: Item.Year.TypeConfig.panel.style()
            },
            display: 'Year',
            image: ''
        },
        {
            id: 'itemMedium',
            component: Item.Medium.Component,
            config: {
                Block: Item.Medium.TypeConfig.panel.block(),
                Visibility: Item.Medium.TypeConfig.panel.visibility(),
                Style: Item.Medium.TypeConfig.panel.style()
            },
            display: 'Medium',
            image: ''
        },
        {
            id: 'itemSignature',
            component: Item.Signature.Component,
            config: {
                Block: Item.Signature.TypeConfig.panel.block(),
                Visibility: Item.Signature.TypeConfig.panel.visibility(),
                Style: Item.Signature.TypeConfig.panel.style()
            },
            display: 'Signature Placement',
            image: ''
        },
        {
            id: 'itemDimensions',
            component: Item.Dimensions.Component,
            config: {
                Block: Item.Dimensions.TypeConfig.panel.block(),
                Visibility: Item.Dimensions.TypeConfig.panel.visibility(),
                Style: Item.Dimensions.TypeConfig.panel.style()
            },
            display: 'Dimensions',
            image: ''
        },
        {
            id: 'itemNumber',
            component: Item.Number.Component,
            config: {
                Block: Item.Number.TypeConfig.panel.block(),
                Visibility: Item.Number.TypeConfig.panel.visibility(),
                Style: Item.Number.TypeConfig.panel.style()
            },
            display: 'Inventory Number',
            image: ''
        },
        {
            id: 'itemSKU',
            component: Item.SKU.Component,
            config: {
                Block: Item.SKU.TypeConfig.panel.block(),
                Visibility: Item.SKU.TypeConfig.panel.visibility(),
                Style: Item.SKU.TypeConfig.panel.style()
            },
            display: 'SKU',
            image: ''
        },
        {
            id: 'itemPrice',
            component: Item.Price.Component,
            config: {
                Block: Item.Price.TypeConfig.panel.block(),
                Visibility: Item.Price.TypeConfig.panel.visibility(),
                Style: Item.Price.TypeConfig.panel.style(),
                Format: Item.Price.TypeConfig.panel.format()
            },
            display: 'Price',
            image: ''
        },
        {
            id: 'itemCustomMeta',
            component: Item.CustomMeta.Component,
            config: {
                Block: Item.CustomMeta.TypeConfig.panel.block(),
                Meta: Item.CustomMeta.TypeConfig.panel.meta(),
                Includes: Item.CustomMeta.TypeConfig.panel.includes(),
                Style: Item.CustomMeta.TypeConfig.panel.style()
            },
            display: 'Customized Details',
            image: ''
        },
        {
            id: 'itemArtistBio',
            component: Item.ArtistBio.Component,
            config: {
                Block: Item.ArtistBio.TypeConfig.panel.block(),
                Includes: Item.ArtistBio.TypeConfig.panel.includes(),
                Visibility: Item.ArtistBio.TypeConfig.panel.visibility(),
                Style: Item.ArtistBio.TypeConfig.panel.style()
            },
            display: 'Artist Biography',
            image: ''
        },
        {
            id: 'itemInsuranceValue',
            component: Item.InsuranceValue.Component,
            config: {
                Block: Item.InsuranceValue.TypeConfig.panel.block(),
                Style: Item.InsuranceValue.TypeConfig.panel.style(),
                Format: Item.InsuranceValue.TypeConfig.panel.format()
            },
            display: 'Insurance Value',
            image: ''
        },
        {
            id: 'itemNotes',
            component: Item.Notes.Component,
            config: {
                Block: Item.Notes.TypeConfig.panel.block(),
                Visibility: Item.Notes.TypeConfig.panel.visibility(),
                Style: Item.Notes.TypeConfig.panel.style()
            },
            display: 'Notes',
            image: ''
        },
    ]
};

module.exports = {
    Blocks
};